var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOntime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.2A7.2 7.2 0 108 .8a7.2 7.2 0 000 14.4z",
    fill: "#FA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 4.6v3.6h3.6",
    stroke: "#fff",
    strokeWidth: 1.35,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik04LjAwMDA1IDE1LjJDMTEuOTc2NSAxNS4yIDE1LjIgMTEuOTc2NSAxNS4yIDguMDAwMDVDMTUuMiA0LjAyMzYgMTEuOTc2NSAwLjgwMDA0OSA4LjAwMDA1IDAuODAwMDQ5QzQuMDIzNiAwLjgwMDA0OSAwLjgwMDA0OSA0LjAyMzYgMC44MDAwNDkgOC4wMDAwNUMwLjgwMDA0OSAxMS45NzY1IDQuMDIzNiAxNS4yIDguMDAwMDUgMTUuMloiIGZpbGw9IiNGRkFBMDAiLz4KICAgIDxwYXRoIGQ9Ik03LjgwMDA1IDQuNjAwMVY4LjIwMDFIMTEuNCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjM1IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8L3N2Zz4KICAgIA==";
export { SvgOntime as ReactComponent };